import { render, staticRenderFns } from "./交易项目.vue?vue&type=template&id=f380e72e&scoped=true"
import script from "./交易项目.vue?vue&type=script&lang=js"
export * from "./交易项目.vue?vue&type=script&lang=js"
import style0 from "./交易项目.vue?vue&type=style&index=0&id=f380e72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f380e72e",
  null
  
)

export default component.exports